import ApplicationSerializer from 'eflex/serializers/application';

export default class BuildStatusSerializer extends ApplicationSerializer {
  attrs = {
    children: {
      embedded: 'always',
    },
    customIdentifierData: {
      embedded: 'always',
    },
  };
}
